(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDeleteController',MonedaDeleteController);

    MonedaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Moneda'];

    function MonedaDeleteController($uibModalInstance, entity, Moneda) {
        var vm = this;

        vm.moneda = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Moneda.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
